import { Button, Link } from "@cvpartner/design-system";
import { ArrowLeft } from "@cvpartner/design-system/icons/line";
import type * as React from "react";
import { ClientRouter } from "@/shared/ui/Link.tsx";
import { I18n } from "@/shared/util/translations.ts";
import {
  LoginButtonWrapper,
  LoginLinkWrapper,
  Wrapper,
} from "./shared/Modern.tsx";

export const ResetPasswordReceipt: React.FC = () => (
  <Wrapper
    heading={I18n.t("forgot_password.header_title_receipt")}
    subheading={I18n.t("forgot_password.header_subtitle_receipt_instructions")}
  >
    <LoginLinkWrapper>
      <Link hierarchy="primary" href="/login" size="s" leadingIcon={ArrowLeft}>
        {I18n.t("forgot_password.link_back_to_signin")}
      </Link>
    </LoginLinkWrapper>
    <LoginButtonWrapper center={true}>
      <ClientRouter>
        <Button variant="link" hierarchy="tertiary" href="/login/troubleshoot">
          {I18n.t("signin.alert.signin_failed_bt_troubleshoot")}
        </Button>
      </ClientRouter>
    </LoginButtonWrapper>
  </Wrapper>
);
